import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: false,
    userData: null,
  },
  reducers: {
    reduxLogin: (state, action) => {
      state.isAuthenticated = true;
      state.userData = action.payload;
      localStorage.setItem("zahranUserData", JSON.stringify(action.payload));
    },
    restoreAuth: (state, action) => {
      state.isAuthenticated = true;
      state.userData = action.payload;
    },
    reduxLogout: (state) => {
      state.isAuthenticated = false;
      state.userData = null;
      localStorage.removeItem("zahranUserData");
    },
    // ... other reducers
  },
});

export const { reduxLogin, reduxLogout, restoreAuth } = authSlice.actions;

export default authSlice.reducer;
